import { TopServiceModeAppHeaderDefaultView } from './top-service-mode-app-header-default.view';
import { ITopServiceModeViewProps } from './types';

export const TopServiceModeAppHeaderView: React.FC<React.PropsWithChildren<
  ITopServiceModeViewProps
>> = props => {
  return <TopServiceModeAppHeaderDefaultView {...props} />;
};
